import {coreApi} from './core'

export const vehicleService = {
    getAllOwners: async (params) => coreApi.get(`vehicle/owner`, {params}),
    getByIdOwner: async (params) => coreApi.get(`vehicle/owner`, {params}),
    getAll: async (params) => coreApi.get(`vehicle`, {params}),
    getById: async (params) => coreApi.get(`vehicle`, {params}),
    create: async (data, type) => coreApi.post(`vehicle?isOwn=${type}`, data),
    update: async (data, type) => coreApi.put(`vehicle?isOwn=${type}`, data)
}